import {
	Box,
	Button,
	Col,
	Component,
	Dropdown,
	Grid,
	Heading,
	Icons,
	Inline,
	Stack,
	Table,
	Text,
	Time,
} from "@sembark-travel/ui/base"
import { Dialog } from "@sembark-travel/ui/dialog"
import { showSnackbar } from "@sembark-travel/ui/snackbar"
import { Markdown } from "@sembark-travel/ui/markdown"
import { xhr } from "@sembark-travel/xhr"
import { hotelNotesXHR, THotelNote } from "./store"
import { IRoomType } from "../RoomTypes"
import { IMealPlan } from "../MealPlans"
import { CreateHotelNotes, UpdatedHotelNotes } from "./NewItem"
import { Breadcrumbs, useLocationQuery } from "@sembark-travel/ui/router"
import { generatePath } from "../router-utils"
import { ListView, useSearch } from "@sembark-travel/ui/list"
import { useEffect, useState } from "react"

export function HotelNotesList({
	notes,
	roomTypes,
	mealPlans,
	hotelId,
	isGlobalNotes = false,
	onChange,
}: {
	mealPlans?: IMealPlan[]
	notes?: THotelNote[]
	roomTypes?: IRoomType[]
	hotelId?: number
	isGlobalNotes?: boolean
	onChange: () => void
}) {
	return (
		<Box>
			{notes?.length ? (
				<Box backgroundColor={"default"}>
					{notes.map((note) => (
						<Stack
							key={note.id}
							paddingX={"6"}
							paddingY={"4"}
							gap={"4"}
							borderBottomWidth={"1"}
						>
							<Grid>
								<Col sm={12} md={4} paddingX={"0"}>
									<Grid>
										<Col paddingX={"0"}>
											<Table responsive>
												<tbody>
													<tr>
														<td
															style={{
																width: "100px",
																textAlign: "left",
																verticalAlign: "top",
															}}
														>
															<Text fontWeight="semibold" color="muted">
																Share With:
															</Text>
														</td>
														<td style={{ textAlign: "left" }}>
															<Text>
																•{" "}
																{note.show_in_voucher && note.show_in_quote
																	? "Quotation and Voucher"
																	: note.show_in_voucher
																		? "Voucher only"
																		: note.show_in_quote
																			? "Quotation only"
																			: "Internal use only"}
															</Text>
														</td>
													</tr>
													<tr>
														<td
															style={{
																width: "100px",
																textAlign: "left",
																verticalAlign: "top",
															}}
														>
															<Text
																fontWeight="semibold"
																color="muted"
																whiteSpace={"nowrap"}
															>
																Room Type:
															</Text>
														</td>

														<td style={{ textAlign: "left" }}>
															<Stack>
																{note.room_types?.length
																	? note.room_types.map((r, i) => (
																			<Text key={i}>• {r.name}</Text>
																		))
																	: "• ALL"}
															</Stack>
														</td>
													</tr>
													<tr>
														<td
															style={{
																width: "100px",
																textAlign: "left",
																verticalAlign: "top",
															}}
														>
															<Text fontWeight="semibold" color="muted">
																Date Range:{" "}
															</Text>
														</td>
														<td style={{ textAlign: "left" }}>
															<Stack>
																{note.date_ranges?.length
																	? note.date_ranges.map((d, i) => (
																			<Text key={i}>
																				•{" "}
																				{d.start_date ? (
																					<Time value={d.start_date} />
																				) : (
																					"ALL"
																				)}{" "}
																				-{" "}
																				{d.end_date ? (
																					<Time value={d.end_date} />
																				) : (
																					"ALL"
																				)}
																			</Text>
																		))
																	: "• ALL"}
															</Stack>
														</td>
													</tr>
													<tr>
														<td
															style={{
																width: "100px",
																textAlign: "left",
																verticalAlign: "top",
															}}
														>
															<Text fontWeight="semibold" color="muted">
																Meal Plan:{" "}
															</Text>
														</td>
														<td style={{ textAlign: "left" }}>
															<Text>
																•{" "}
																{note.meal_plans?.length
																	? note.meal_plans
																			.map((m) => m.name)
																			.join(" • ")
																	: " ALL"}
															</Text>
														</td>
													</tr>
												</tbody>
											</Table>
										</Col>
										<Col xs={1} sm={1} lg={1} paddingX={"0"}>
											<Inline justifyContent={"end"}>
												<Dropdown alignRight>
													<Dropdown.ToggleButton level="tertiary" size="sm">
														<Icons.DotsVertical />
													</Dropdown.ToggleButton>
													<Dropdown.Menu>
														<Component initialState={false}>
															{({ state, setState }) => (
																<>
																	<Dropdown.MenuItem
																		onClick={() => setState(true)}
																	>
																		<Icons.Pencil /> Edit Note
																	</Dropdown.MenuItem>
																	<Dialog
																		open={state}
																		onClose={() => setState(false)}
																		xl
																	>
																		<Dialog.Header>
																			<Dialog.Title>
																				Edit Hotel Notes{" "}
																			</Dialog.Title>
																		</Dialog.Header>
																		<Dialog.Body>
																			<UpdatedHotelNotes
																				roomTypes={roomTypes}
																				mealPlans={mealPlans}
																				note={note}
																				refresh={() => {
																					onChange()
																					setState(false)
																				}}
																				isGlobalNotes={isGlobalNotes}
																			/>
																		</Dialog.Body>
																	</Dialog>
																</>
															)}
														</Component>
														<Dropdown.MenuItem
															onClick={() => {
																if (
																	window.confirm(
																		"Are you sure you want to delete this hotel note ?"
																	)
																) {
																	hotelNotesXHR(xhr)
																		.destroyNote(note.id)
																		.then((resp) => {
																			showSnackbar(
																				resp.message ||
																					"Note deleted successfully."
																			)
																			onChange()
																		})
																		.catch((e) => {
																			const error: Error = e
																			window.alert(
																				error.message || "Something went wrong"
																			)
																		})
																}
															}}
														>
															<Icons.Trash /> Delete
														</Dropdown.MenuItem>
													</Dropdown.Menu>
												</Dropdown>
											</Inline>
										</Col>
									</Grid>
								</Col>
								<Col paddingX={"0"}>
									<Box
										paddingX={"4"}
										paddingY={"2"}
										borderColor="accent"
										backgroundColor="accent"
										borderWidth={"1"}
										rounded="md"
									>
										<Markdown>{note.description}</Markdown>
									</Box>
								</Col>
							</Grid>
						</Stack>
					))}
				</Box>
			) : (
				<Box paddingTop="4">
					<Box paddingY="16">
						<Stack gap="6" alignItems="center">
							<Icons.Info size="12" color="muted" />
							<Heading as="h3" fontSize="lg" fontWeight="normal">
								There are currently no notes.
							</Heading>
							<Box>
								<Component initialState={false}>
									{({ state, setState }) => (
										<>
											<Button onClick={() => setState(true)} size="sm">
												<Icons.Plus /> Create Notes
											</Button>
											<Dialog open={state} onClose={() => setState(false)} xl>
												<Dialog.Header>
													<Dialog.Title>
														{isGlobalNotes
															? "Create General Hotel Notes"
															: "Create Hotel Notes"}
													</Dialog.Title>
												</Dialog.Header>
												<Dialog.Body>
													<CreateHotelNotes
														roomTypes={roomTypes}
														mealPlans={mealPlans}
														hotelId={hotelId}
														onSuccess={() => {
															onChange()
															setState(false)
														}}
														isGlobalNotes={isGlobalNotes}
													/>
												</Dialog.Body>
											</Dialog>
										</>
									)}
								</Component>
							</Box>
						</Stack>
					</Box>
				</Box>
			)}
		</Box>
	)
}

export function GlobalHotelNotesList() {
	const [query, setQuery] = useLocationQuery()
	const [updateList, setForceUpdateList] = useState(1)
	const [params, setParams] = useSearch(query)
	useEffect(() => {
		setQuery(params)
	}, [params, setQuery])
	return (
		<Box>
			<Breadcrumbs
				title="General Hotel Notes"
				items={[[generatePath("/hotels"), "Hotels"]]}
				actions={
					<Component initialState={false}>
						{({ state, setState }) => (
							<>
								<Button onClick={() => setState(true)} size="sm">
									<Icons.Plus /> Create Notes
								</Button>
								<Dialog open={state} onClose={() => setState(false)} xl>
									<Dialog.Header>
										<Dialog.Title>Create General Hotel Notes </Dialog.Title>
									</Dialog.Header>
									<Dialog.Body>
										<CreateHotelNotes
											onSuccess={() => {
												setForceUpdateList((flag) => flag + 1)
												setState(false)
											}}
											isGlobalNotes
										/>
									</Dialog.Body>
								</Dialog>
							</>
						)}
					</Component>
				}
			/>
			<ListView<THotelNote>
				pageKey={`general-hotel-notes-${updateList}`}
				params={params}
				fetch={(xhr, params) =>
					hotelNotesXHR(xhr).getGlobalHotelNotes({ ...params })
				}
				onPageChange={(page) => setParams({ ...params, page })}
			>
				{({ items: data, refresh }) => (
					<HotelNotesList
						notes={data}
						onChange={() => refresh()}
						isGlobalNotes
					/>
				)}
			</ListView>
		</Box>
	)
}
